import * as React from "react"
import * as _ from "lodash"
import {
    IMedicinePrescription,
    IPatientAllergy,
    IPatientConcern,
    IPatientRedFlag,
    IPatientSurgeryAndProcedure
} from "@curefit/ehr-common";
import { PatientPersonalProfile, PatientPersonalInformation } from "@curefit/ups-common";
import { IPatientDetail } from "@curefit/care-common";
import {IAppState} from "../../models/IAppState"
import {connect} from "react-redux"
import * as RoutesConfig from "../../routes"
import {PatientCompleteInfoActions} from "../../actions/PatientCompleteInfoActions"
import AllergyEditViewCont from "../EditView/AllergyEditViewCont"
import SurgeryEditViewCont from "../EditView/SurgeryEditViewCont"
import CurrentMedicationEditViewCont from "../EditView/CurrentMedicationEditViewCont";
import IHabit from "../../models/staticData/IHabit";
import {AppConstants, MedicationTypes} from "../../utils/AppConstants";
import IMedicineType from "../../models/staticData/IMedicineType";
import PastConditionsEditViewCont from "../EditView/PastConditionsEditViewCont";
import IPatientCondition from "../../models/IPatientCondition";
import IStaticData from "../../models/staticData/IStaticData";
import AppUtils from "../../utils/AppUtils";
import {AllStaticDataActions} from "../../actions/AllStaticDataActions";
import IAccountData from "../../models/IAccountData";
import FamilyConditionsEditViewCont from "../EditView/FamilyConditionsEditViewCont";
import ConcernsEditViewCont from "../EditView/ConcernsEditViewCont";
import PersonalInformationEditViewCont from "../EditView/PersonalInformationEditViewCont";
import IinfoQues from "../../models/staticData/IinfoQues";
import RedFlagsEditViewCont from "../EditView/RedFlagsEditViewCont";
import {IEHRSavePatientMedicalProfile} from "../../models/patients/IEHRSavePatientMedicalProfile";
import {ITypeFormResponse} from "../../models/ITypeFormResponse";

/**
 * Created by abhinav on 27/01/18.
 */

/* REQUIREMENT: All Patient Components should be within the parent component which has the patient profile */

export interface PatientMedicalHistoryContainerProps {
    params?: any,
    accountData: IAccountData,
    patientConcerns: IPatientConcern[],
    savePatientConcerns: (patientId: number, medicalHistory: IEHRSavePatientMedicalProfile) => any,
    staticRedFlags: IStaticData,
    patientRedFlags: IPatientRedFlag[],
    savePatientRedFlags: (patientId: number, medicalHistory: IEHRSavePatientMedicalProfile) => any,
    staticConditions: IStaticData,
    patientConditions: IPatientCondition[],
    fetchStaticSymptomsData: (input: string) => Promise<any>,
    patientSurgeries: IPatientSurgeryAndProcedure[],
    fetchPatientSurgeries: (patientId: number) => any,
    savePatientSurgeries: (patientId: number, patientSurgeries: IPatientSurgeryAndProcedure[]) => any,
    patientAllergies: IPatientAllergy[],
    fetchPatientAllergies: (patientId: number) => any,
    savePatientAllergies: (patientId: number, patientAllergies: IPatientAllergy[]) => IPatientAllergy[],
    patientHabits: IHabit[],
    savePatientHabits: (patientId: number, patientHabits: IHabit[]) => any,
    fetchPatientHabits: (patientId: number) => any,
    staticMedicineTypes: IMedicineType[],
    patientCurrentMedication: IMedicinePrescription[],
    fetchCurrentMedication: (patientId: number) => any,
    saveCurrentMedication: (patientId: number, currentMedications: IMedicinePrescription[]) => any,
    fetchComorbidConditions: (patientId: number) => Promise<IPatientCondition[]>,
    saveComorbidConditions: (patientId: number, conditions: IPatientCondition[]) => any,
    staticPersonalInfo: IinfoQues,
    patientPersonalProfile: PatientPersonalProfile,
    savePatientPersonalInfo: (curefitId: string, patientId: number, isSelf: boolean, profile: PatientPersonalInformation) => any,
    patientProfile: IPatientDetail,
    fetchAllStaticData: () => any,
    patientTypeFormData: ITypeFormResponse;
    typeFormMapping: any;
}

export interface PatientMedicalHistoryContainerState {}

class PatientMedicalHistoryContainer extends React.Component<PatientMedicalHistoryContainerProps, PatientMedicalHistoryContainerState> {

    constructor(props: PatientMedicalHistoryContainerProps) {
        super(props);
    }

    componentDidMount() {
        if (_.isNull(this.props.staticMedicineTypes)) {
            this.props.fetchAllStaticData();
        }
    }

    getPatientId = () => {
        return parseInt(this.props.params[RoutesConfig.PATIENT_ID_PARAM]);
    }

    getCurefitId = () => {
        let userId = this.props.patientProfile.relationship && this.props.patientProfile.relationship.toUpperCase() === AppConstants.patientRelationships.SELF ? this.props.patientProfile.curefitUserId :
                        this.props.patientProfile.curefitUserId + "-" + this.props.patientProfile.id;
        return userId;
    }

    savePatientConcerns = (patientId: number, concerns: IPatientConcern[]) => {
        let medicalProfile: IEHRSavePatientMedicalProfile = { concerns: concerns };
        this.props.savePatientConcerns(patientId, medicalProfile);
    }

    savePatientRedFlags = (patientId: number, redFlags: IPatientRedFlag[]) => {
        let medicalProfile: IEHRSavePatientMedicalProfile = { redFlags: redFlags};
        this.props.savePatientRedFlags(patientId, medicalProfile);
    }

    render() {
        let unformattedPastConditions = this.props.patientConditions.filter(item => item.relationship === AppConstants.PatientRelationshipConstant.SELF.internalValue);
        let patientConditions = AppUtils.convertListToUIPastConditions(unformattedPastConditions);
        let unformattedFamilyConditions = this.props.patientConditions.filter(item => item.relationship !== AppConstants.PatientRelationshipConstant.SELF.internalValue);
        let familyConditions = AppUtils.convertListToUIPastConditions(unformattedFamilyConditions);
        let patientRedFlags = !_.isEmpty(this.props.patientRedFlags) ? this.props.patientRedFlags[0] : null;
        let questionnaire = !_.isEmpty(this.props.patientTypeFormData) && !_.isEmpty(this.props.patientTypeFormData.userForm) &&
            !_.isEmpty(this.props.patientTypeFormData.userForm.questionResponseDetails) ? this.props.patientTypeFormData.userForm.questionResponseDetails : [];
        let patientPersonalInformation = !_.isEmpty(this.props.patientPersonalProfile) && !_.isEmpty(this.props.patientPersonalProfile.personalInformation) ? this.props.patientPersonalProfile.personalInformation : {};
        let isSelf = !_.isEmpty(this.props.patientProfile) && !_.isEmpty(this.props.patientProfile.relationship) ? this.props.patientProfile.relationship.toUpperCase() === AppConstants.patientRelationships.SELF : false;
        return (
            <div className="patient-info-section">

                <div className="patient-section-header">Medical History</div>

                <div className="patient-info-subsection concerns-section">
                    <ConcernsEditViewCont patientId={this.getPatientId()} patientConcerns={this.props.patientConcerns}
                                          fetchStaticSymptomData={this.props.fetchStaticSymptomsData} savePatientConcerns={this.savePatientConcerns}
                                          editedBy={AppUtils.getEditedBy(this.props.accountData)}
                                          questionnaire={questionnaire} typeFormMapping={this.props.typeFormMapping}/>
                </div>

                <div className="patient-info-subsection condition-section">
                    <PastConditionsEditViewCont patientId={this.getPatientId()} patientConditions={patientConditions} familyConditions={unformattedFamilyConditions}
                                                staticConditions={this.props.staticConditions.values} fetchStaticSymptomsData={this.props.fetchStaticSymptomsData}
                                                savePatientConditions={this.props.saveComorbidConditions}
                                                editedBy={AppUtils.getEditedBy(this.props.accountData)}
                                                questionnaire={questionnaire} typeFormMapping={this.props.typeFormMapping} />
                </div>

                <div className="patient-info-subsection family-condition-section">
                    <FamilyConditionsEditViewCont patientId={this.getPatientId()} patientConditions={familyConditions} selfConditions={unformattedPastConditions}
                                                staticConditions={this.props.staticConditions.values} fetchStaticSymptomsData={this.props.fetchStaticSymptomsData}
                                                savePatientConditions={this.props.saveComorbidConditions}
                                                editedBy={AppUtils.getEditedBy(this.props.accountData)}
                                                questionnaire={questionnaire} typeFormMapping={this.props.typeFormMapping} />
                </div>

                <div className="patient-info-subsection surgery-section">
                    <SurgeryEditViewCont patientId={this.getPatientId()} patientSurgeries={this.props.patientSurgeries}
                                         fetchPatientSurgeries={this.props.fetchPatientSurgeries}
                                         savePatientSurgeries={this.props.savePatientSurgeries}
                                         editedBy={AppUtils.getEditedBy(this.props.accountData)}
                                         questionnaire={questionnaire} typeFormMapping={this.props.typeFormMapping} />
                </div>

                <div className="patient-info-subsection allergy-section">
                    <AllergyEditViewCont patientId={this.getPatientId()} patientAllergies={this.props.patientAllergies}
                                         fetchPatientAllergies={this.props.fetchPatientAllergies}
                                         savePatientAllergies={this.props.savePatientAllergies}
                                         questionnaire={questionnaire} typeFormMapping={this.props.typeFormMapping} />
                </div>

                <div className="patient-info-subsection redFlag-section">
                    <RedFlagsEditViewCont patientId={this.getPatientId()} staticRedFlags={this.props.staticRedFlags.values}
                                          patientRedFlags={patientRedFlags} savePatientRedFlags={this.savePatientRedFlags}
                                          editedBy={AppUtils.getEditedBy(this.props.accountData)}
                                          questionnaire={questionnaire} typeFormMapping={this.props.typeFormMapping} />
                </div>

                <div className="patient-info-subsection habits-section">
                    <PersonalInformationEditViewCont personalInformation={patientPersonalInformation} staticPersonalInfo={this.props.staticPersonalInfo}
                                                     patientId={this.getPatientId()} curefitId={this.getCurefitId()} isSelf={isSelf}
                                                     savePatientPersonalInfo={this.props.savePatientPersonalInfo}
                                                     questionnaire={questionnaire} typeFormMapping={this.props.typeFormMapping}/>
                </div>

                <div className="patient-info-subsection current-medication-section">
                    <CurrentMedicationEditViewCont patientId={this.getPatientId()} patientMedication={this.props.patientCurrentMedication}
                                       staticMedicineTypes={this.props.staticMedicineTypes} fetchPatientMedication={this.props.fetchCurrentMedication}
                                       savePatientMedication={this.props.saveCurrentMedication} medicationType={MedicationTypes.ACTIVE}
                                       questionnaire={questionnaire} typeFormMapping={this.props.typeFormMapping}/>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: IAppState) => {
    return {
        accountData: state.accountData,
        staticMedicineTypes: state.allStaticDataNew.medicalTypeList,
        staticConditions: state.allStaticDataNew.pastConditions,
        patientConcerns: state.patientCompleteInfo.concerns,
        staticRedFlags: state.allStaticDataNew.redFlags,
        patientRedFlags: state.patientCompleteInfo.redFlags,
        patientConditions: state.patientCompleteInfo.comorbidCondition,
        patientSurgeries: state.patientCompleteInfo.surgeryAndProcedure,
        patientAllergies: state.patientCompleteInfo.allergies,
        patientHabits: state.patientCompleteInfo.habits,
        patientCurrentMedication: state.patientCompleteInfo.currentMedication,
        staticPersonalInfo: state.allStaticDataNew.personalInformation,
        patientPersonalProfile: state.patientCompleteInfo.personalInfo,
        patientProfile: state.patientCompleteInfo.profile,
        patientTypeFormData: state.patientCompleteInfo.typeFormData,
        typeFormMapping: state.allStaticDataNew.typeFormMapping
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        fetchStaticSymptomsData: (input: string) => {
            return AllStaticDataActions.fetchStaticSymptomsData(input);
        },
        fetchPatientSurgeries: (patientId: number) => {
            return PatientCompleteInfoActions.fetchPatientSurgeryData(dispatch, patientId);
        },
        savePatientSurgeries: (patientId: number, surgeryData: IPatientSurgeryAndProcedure[]) => {
            return PatientCompleteInfoActions.savePatientSurgeryData(dispatch, patientId, surgeryData);
        },
        fetchPatientAllergies: (patientId: number) => {
            return PatientCompleteInfoActions.fetchPatientAllergyData(dispatch, patientId);
        },
        savePatientAllergies: (patientId: number, patientAllergies: IPatientAllergy[]) => {
            return PatientCompleteInfoActions.savePatientAllergyData(dispatch, patientId, patientAllergies);
        },
        fetchPatientHabits: (patientId: number) => {
            return PatientCompleteInfoActions.fetchPatientHabitData(dispatch, patientId);
        },
        savePatientHabits: (patientId: number, patientHabits: IHabit[]) => {
            return PatientCompleteInfoActions.savePatientHabitData(dispatch, patientId, patientHabits);
        },
        fetchCurrentMedication: (patientId: number) => {
            return PatientCompleteInfoActions.fetchPatientCurrentMedicationData(dispatch, patientId);
        },
        saveCurrentMedication: (patientId: number, meds: IMedicinePrescription[]) => {
            return PatientCompleteInfoActions.savePatientCurrentMedicationData(dispatch, patientId, meds);
        },
        fetchComorbidConditions: (patientId: number) => {
            return PatientCompleteInfoActions.fetchPatientComorbidConditionData(dispatch, patientId);
        },
        saveComorbidConditions: (patientId: number, conditions: IPatientCondition[]) => {
            return PatientCompleteInfoActions.savePatientComorbidConditionData(dispatch, patientId, conditions);
        },
        savePatientPersonalInfo: (curefitId: string, patientId: number, isSelf: boolean, profile: PatientPersonalInformation) => {
            return PatientCompleteInfoActions.savePatientPersonalInformation(dispatch, curefitId, patientId, isSelf, { personalInformation: profile })
        },
        savePatientConcerns: (patientId: number, medicalHistory: IEHRSavePatientMedicalProfile) => {
            return PatientCompleteInfoActions.savePatientConcerns(dispatch, patientId, medicalHistory)
        },
        savePatientRedFlags: (patientId: number, medicalHistory: IEHRSavePatientMedicalProfile) => {
            return PatientCompleteInfoActions.savePatientRedFlags(dispatch, patientId, medicalHistory)
        },
        fetchAllStaticData: () => {
            return AllStaticDataActions.fetchAllStaticData(dispatch);
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PatientMedicalHistoryContainer as any);
